module.exports = __webpack_public_path__ + "static/media/skrinig40_52x48.9ae6df5a.svg";